<script>
import TWEEN from 'tween.js'
import RND from '../utils/random'

const words = ['МИМО!', 'ПОЧТИ', 'ЦЕЛЬСЯ ЛУЧШЕ', 'МЕНЯ НЕ УБИТЬ']

export default {
	name: 'BadStory2',
	props: ['alpha'],
	data() {
		return {
			title: 'Убей зомби',
			body: 'Пока он тебя<br>не укусил',
			sX: 0,
			sY: 0,
			textY: 0,
			textOpacity: 0,
			text: RND.from(words),
			animating: false
		}
	},
	mounted() {
		let bounds = this.$el.getBoundingClientRect()
		this.sX = bounds.width / 1.5
		this.sY = bounds.height / 3
	},
	computed: {
		sightStyle() {
			return {transform: `translateX(${this.sX}px) translateY(${this.sY}px)`}
		},
		textStyle() {
			return {transform: `translateY(${this.textY}px)`, opacity: this.textOpacity}
		}
	},
	methods: {
		onMove(e) {
			this.sX = e.layerX
			this.sY = e.layerY
		},
		onClick(e) {
			if (this.animating) return

			this.animating = true
			this.text = RND.from(words)

			let _this = this
			let tw = new TWEEN.Tween({y: 0, a: 1})
				.to({y: -100, a: 0}, 500)
				.onUpdate(function (e) {
					_this.textY = this.y
					_this.textOpacity = this.a
				})
				.onComplete(() => this.animating = false)
				.start()

		}
	}
}
</script>



<template>
<div class="story small" @mousemove="onMove" @click="onClick" :style="{opacity: alpha}">
	<img class="image"  src="../assets/bad/story2.gif">
	<div class="mask">
		<h2 v-html="title"></h2>
		<p v-html="body"></p>
	</div>
	<div class="sight" :style="sightStyle">
		<img src="../assets/bad/sight.svg">
		<div class="text" :style="textStyle">{{ text }}</div>
	</div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	background: #000;
}

.small {
	width: 25vw;
	height: 25vw;
}

.image {
	width: 101%;
	height: 101%;
	position: absolute;
	background-size: cover;
	background-position: center;
	transition: all 300ms ease;
}

.mask {
	width: 100%;
	height: 102%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

h2 {
	width: 90%;
	margin: 0 auto;
	font-size: 23px;
}

p {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5vh;
	font-size: 23px;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}

.sight {
	width: 6vw;
	height: 6vw;
	position: absolute;
	left: 0;
	top: 0;
	margin-left: -3vw;
	margin-top: -3vw;
	pointer-events: none;
}

.sight img {
	width: 100%;
	position: absolute;
	animation: sight 3s infinite;
}

.sight .text {
	width: 100%;
	position: absolute;
	color: #fff;
	margin-top: 1vw;
	text-align: center;
	opacity: 0;
}

@keyframes sight {
	0% {
		transform: rotate(0) scale(1);
	}
	25% {
		transform: rotate(10deg) scale(1.2);
	}
	50% {
		transform: rotate(0) scale(1);
	}
	75% {
		transform: rotate(-10deg) scale(1.2);
	}
	100% {
		transform: rotate(0) scale(1);
	}
}

</style>



// WEBPACK FOOTER //
// BadStory2.vue?23e54614